import 'cropperjs/dist/cropper.css'

import {
    Button, Dialog, DialogContent, DialogTitle, Slider
} from '@material-ui/core'
import * as Assert from 'assert'
import Cropper from 'cropperjs'
import React from 'react'
import ReactCropper from 'react-cropper'

import { buttonsStyles } from '../../styles/ButtonsStyles'
import { getFileInfo } from '../../utils/helper'

const maxZoomRatio = 4

type Props = {
    file?: File,
    cropWidth: number,
    cropHeight: number,
    onEdit (file: File | undefined): void,
};

export const CropperModal: React.FC<Props> = ({
    file, onEdit, cropWidth, cropHeight
}) => {
    const [cropper, setCropper] = React.useState<Cropper>()
    const [image, setImage] = React.useState<string>()
    const [zoom, setZoom] = React.useState<number>(1)
    const [rotate, setRotate] = React.useState<number>(0)

    const btnStyles = buttonsStyles()
    React.useEffect(() => {
        if (file) {
            const reader = new FileReader()
            reader.addEventListener('load', () => {
                setImage(reader.result as string)

                if (cropper) {
                    cropper
                        .zoomTo(1)
                        .rotateTo(0)
                }
            })

            reader.readAsDataURL(file)
        } else {
            setImage(undefined)
            setCropper(undefined)
        }
    }, [file, cropper])

    const onConfirm = (): void => {
        if (!cropper) {
            return
        }

        const croppedCanvas: any = {
            minWidth: 854,
            maxWidth: 1200,
            minHeight: 480,
            maxHeight: 600,
            imageSmoothingQuality: 'medium',
        }

        const canvasData: HTMLCanvasElement = cropper.getCroppedCanvas(croppedCanvas)
        const fileInfo = getFileInfo(file)

        canvasData.toBlob((blob) => {
            Assert.ok(blob)
            const croppedFile = new File([blob], fileInfo.filename, {
                type: blob.type,
                lastModified: new Date().valueOf()
            })

            onEdit(croppedFile)

            setImage(undefined)
            setCropper(undefined)
        }, fileInfo.mime, 100)
    }

    const handleClose = (): void => {
        setCropper(undefined)
        setImage(undefined)
        onEdit(undefined)
    }

    const updateZoom = (event: Cropper.ZoomEvent<HTMLImageElement>) => {
        const zoomRatio = Math.min(event.detail.ratio, maxZoomRatio)
        if (zoomRatio >= maxZoomRatio) {
            event.preventDefault()
        }
        setZoom(
            zoomRatio
        )
    }

    return (
        <Dialog
            style={{
                padding: 15,
                backdropFilter: 'blur(3px)',
                backgroundColor: 'rgba(0,0,30,0.4)'
            }}
            open={(!!file && !!image)}
            onClose={handleClose}
            keepMounted
            aria-describedby="alert-dialog-slide-description">
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <DialogTitle style={{ color: 'white' }}>Beskær billede</DialogTitle>
            </div>
            <DialogContent>
                {image && (
                    <ReactCropper
                        src={image}
                        style={{ height: 500, width: '100%' }}
                        viewMode={1}
                        dragMode="move"
                        cropBoxResizable={false}
                        cropBoxMovable={false}
                        center
                        toggleDragModeOnDblclick={false}
                        checkOrientation
                        onInitialized={(instance) => setCropper(instance)}
                        initialAspectRatio={cropWidth / cropHeight}
                        minCropBoxWidth={cropWidth}
                        minCropBoxHeight={cropHeight}
                        zoom={updateZoom}/>
                )}
            </DialogContent>
            {cropper && (
                <div style={{ padding: '15px 25px' }}>
                    <small style={{ color: 'white' }}>Zoom</small>
                    <Slider
                        style={{ color: '#33949E' }}
                        min={0}
                        step={0.1}
                        max={maxZoomRatio}
                        value={zoom}
                        onChange={(e, value) => {
                            setZoom(value as number); cropper!!.zoomTo(value as number)
                        }}/>
                    <small style={{ color: 'white' }}>Rotere</small>
                    <Slider
                        style={{ color: '#33949E' }}
                        min={-180}
                        max={180}
                        value={rotate}
                        onChange={(e, value) => {
                            setRotate(value as number); cropper!!.rotateTo(value as number)
                        }}/>
                </div>
            )}
            <div style={{ padding: '15px 25px' }}>
                <Button className={btnStyles.saveButton} onClick={onConfirm}>
                    Bekræft
                </Button>
                <Button className={btnStyles.cancelButton} onClick={handleClose}>
                    Annuller
                </Button>
            </div>
        </Dialog>
    )
}

CropperModal.defaultProps = {
    file: undefined
}
